<template>
  <div
    class="min-height-for-section mb_controller w-100 h-100 pt-livetv bg-blur"
    style="margin-bottom: 120px;overflow-x: hidden;"
  >
    <div class="container-fluid mt-3">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Carian</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-2 mt-md-4 mb-3 px-2 px-3">
      <div class="row container-fluid align-items-center p-3 inputBgColor">
        <div class="col-12 col-md-10 mb-3 mb-md-0 px-0 pr-md-3">
          <div
            class="w-100 d-flex justify-content-space-around searchinputstyle mx-md-2"
          >
            <div
              class="col-11 inputbox pl-3 d-flex justify-content-center align-items-center"
            >
              <input
                v-model="searchinput"
                placeholder="Cari mengikut Tajuk, Pelakon atau Tahun"
                style="width:100%;"
                @input="searchRecord()"
              />
            </div>
            <div
              class="col-1 closebutton d-flex justify-content-end align-items-center px-0"
              @click="clearQuery()"
            >
              <span class="closeicon">X</span>
              <!-- <span class="close_text d-none d-md-block">Clear</span> -->
            </div>
          </div>
        </div>
        <div class="col-12 col-md-2 px-0">
          <div class="form-group mb-0">
            <select
              class="custom-select form-control"
              id="exampleFormControlSelect1"
              @change="onChangeSite($event)"
            >
              <option value="title">Tajuk</option>
              <option value="cast">Pelakon</option>
              <option value="year">Tahun</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="w-100 d-flex flex-row justify-content-center flex-wrap">
            <div
              :class="[
                currentEpisodeId === category.id
                  ? 'tagWrapper selectedCategory m-1'
                  : 'tagWrapper m-1',
              ]"
              v-for="(category, index) in category_list"
              :key="index + category.id"
              @click="getCategoriesItems(category.id, category.value.en_US)"
            >
              <p class="mb-0 tagTitle">{{ category.value.en_US }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div
        class="row px-3 px-md-2 mt-4 pb-5"
        style="margin-bottom: 30px;"
        v-if="vodArr.length > 0"
      >
        <div class="col-12 text-left mb-4">
          <p class="mb-0 searchResultHeader">
            Rancangan berkaitan:
            <span class="searchInputText">{{ searchinput }}</span>
          </p>
        </div>
        <div class="col-12 mb-1">
          <p class="mb-0 popularText text-left">Popular</p>
        </div>
        <div
          class="col-6 col-sm-4 col-md-3 col-lg-2 px-2 py-2 cursor-pointer item"
          v-for="(item_vod, index) in vodArr"
          :key="'carian' + index"
          @click="goTo(getAssetLink(item_vod))"
        >
          <vodPotraitCard
            :image="item_vod.img_link"
            :title="item_vod.longTitle"
            :link="getAssetLink(item_vod)"
            :latestTag="formatTimestamp(item_vod.dateAvailability)"
            :data="item_vod.data"
            :itemID="item_vod.id"
          />
        </div>
      </div>
      <div class="row px-2 my-4" v-if="!loading && noResult">
        <div class="col-12">
          <p class="type-title pl-2">
            Tiada rekod dijumpai
          </p>
        </div>
      </div>
      <div class="row px-2 my-4">
        <div
          v-if="loading"
          class="col-12"
          style="min-height: 30vh; display: flex; align-items: flex-start;justify-content: center;color: white;"
        >
          <p>loading</p>
        </div>
      </div>
    </div>
    <div
      class="container-fluid mb-5 px-3 px-md-4"
      style="padding-bottom: 100px !important;"
      v-if="categories_item.length > 0"
    >
      <div class="row">
        <div class="col-8 mb-1">
          <p class="mb-0 headerTitle text-left">
            {{ categoryTitle }}
          </p>
        </div>
        <div class="col-4 cursor-pointer">
          <p
            class="mb-0 see-more-text text-right"
            @click="clearCategoriesItem()"
          >
            Padam
          </p>
        </div>
      </div>
      <div class="row px-1">
        <div
          class="col-6 col-sm-4 col-md-3 col-lg-2 px-2 py-2 cursor-pointer item"
          v-for="(item, idx) in categories_item"
          :key="'viewall' + idx"
          @click="goTo(getAssetLink(item))"
        >
          <vodPotraitCard
            :image="rtmImgLinkFiltering(item.data.images, '220x300')"
            :title="item.longTitle"
            :link="getAssetLink(item)"
            :latestTag="formatTimestamp(item.dateAvailability)"
            :data="item.data"
            :itemID="item.id"
          />
        </div>
      </div>
      <PopularRailsV2 class="my-2 my-md-4" />
    </div>
    <div v-else-if="currentEpisodeId && categories_item.length === 0">
      <p>Tiada rancangan diketemui.</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable*/
import Vue from "vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import noimage from "../assets/noimage.png";
import axios from "axios";
import landscapeCard from "@/components/cards/v1/landscapeCard.vue";
import vodPotraitCard from "../components/cards/v2/vodPotraitCard.vue";
import PopularRailsV2 from "../components/carousel/homepage/v2/popularVod.vue";
export default {
  components: {
    BreadCrumbsHeader,
    landscapeCard,
    vodPotraitCard,
    PopularRailsV2,
  },
  data: function() {
    return {
      searchinput: "",
      typeOfSearch: "title",
      searchArr: [],
      vodArr: [],
      timeout: null,
      noimage: noimage,
      offset: 0,
      epsColStyles: {},
      window: {
        height: 0,
      },
      loading: false,
      noResult: false,
      category_list: [],
      categories_item: [],
      currentEpisodeId: "",
      categoryTitle: "",
    };
  },
  methods: {
    goTo(link) {
      this.$router.push(link);
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    handleInput(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        this.clearQuery();
      }
    },
    clearQuery() {
      this.searchinput = "";
      this.vodArr = [];
      this.offset = 0;
    },
    searchRecord() {
      clearTimeout(this.timeout);
      var vm = this;
      vm.loading = true;
      vm.vodArr = [];
      vm.offset = 0;

      var url = "";

      if (vm.typeOfSearch === "title") {
        url = `https://rtm.glueapi.io/v3/content?fieldPath=title&fieldValue=*${
          vm.searchinput
        }*&offset=${vm.offset}&limit=100`;
      } else if (vm.typeOfSearch === "cast") {
        url = `https://rtm.glueapi.io/v3/content?fieldPath=cast.actor&fieldValue=*${
          vm.searchinput
        }*&offset=${vm.offset}&limit=100`;
      } else if (vm.typeOfSearch === "year") {
        url = `https://rtm.glueapi.io/v3/content?fieldPath=production_year&fieldValue=*${
          vm.searchinput
        }*&offset=${vm.offset}&limit=100`;
      }

      // this is the correct one for year, but api is down now
      // else if (vm.typeOfSearch === "year") {
      //   url = `https://rtm.glueapi.io/v3/content?fieldPath=production_year&fieldValue=*${
      //     vm.searchinput
      //   }*&offset=${vm.offset}&limit=100`;
      // }

      // console.log(url);

      vm.timeout = setTimeout(async function() {
        // console.log(vm.searchinput);
        if (vm.searchinput) {
          const response = await axios.get(url);

          if (response.data.data.length != 0) {
            vm.getResult(response.data.data, response.data.count);
            vm.noResult = false;
          } else {
            vm.noResult = true;
          }
          vm.loading = false;
        } else {
          vm.clearQuery();
          vm.loading = false;
        }
      }, 2000);
    },
    getResult(value, totalItem) {
      this.offset = this.offset + 50;

      // new
      value.forEach((items, index) => {
        if (
          items.idSchema.toString() != "2012" &&
          items.idSchema.toString() != "2001"
        ) {
          items["img_link"] = items.data.images
            ? this.rtmImgLinkFiltering(items.data.images, "220x300", "poster")
            : noimage;
          this.vodArr.push(items);
        }
        // if (index == value.length - 1) {
        //   // this.searchRecord();
        // }
      });
    },
    handleResize() {
      this.window.height = window.innerHeight;
      var minHeight = this.window.height - 57 + "px";
      Vue.set(this.epsColStyles, "min-height", minHeight);
    },
    onChangeSite(e) {
      var id = e.target.value;
      var name = e.target.options[e.target.options.selectedIndex].text;
      this.typeOfSearch = id;
    },
    clearCategoriesItem() {
      this.currentEpisodeId = "";
      this.categories_item = [];
      this.categoryTitle = "";
    },
    sortCategories(obj) {
      // this.category_list
      var category_id = [];
      obj.forEach((element) => {
        if (
          (element.id != 364) &
          (element.id != 370) &
          (element.id != 380) &
          (element.id != 381) &
          (element.id != 382) &
          (element.id != 499) &
          (element.id != 533) &
          (element.id != 557) &
          (element.id != 660) &
          (element.id != 702) &
          (element.id != 765) &
          (element.id != 982) &
          (element.id != 1082) &
          (element.id != 1279) &
          (element.id != 1285)
        ) {
          category_id.push(element);
        }
      });
      this.category_list = category_id;
    },
    async getCategoriesItems(id, title) {
      this.categoryTitle = title;
      this.currentEpisodeId = id;
      var vm = this;

      let urlLink =
        id == "365"
          ? `https://rtm.glueapi.io/v3/content?idSchema=2007&sort=-dateAvailability&idApp=1`
          : `https://rtm.glueapi.io/v3/content?fieldPath=categories&limit=12&idSchemas=2003,2004,2005,2007,2009&fieldValue=${id}&sort=-dateAvailability&limit=12&idApp=1`;

      let response = await axios.get(urlLink, {
        responseType: "json",
      });
      vm.categories_item = response.data.data;
    },
    async getAllCategories() {
      try {
        axios
          .get(`https://rtm.glueapi.io/v1/content-list/7`)
          .then((response) => {
            this.sortCategories(response.data.data.entries);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
  beforeMount() {
    this.getAllCategories();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.max-container-width {
  max-width: 1280px;
  padding: 0 36px;
  margin: 0 auto;
}
.pt-livetv {
  padding: 20px 0 0;
  min-height: 80vh;
}
.item {
  z-index: 1;
}
.item:hover {
  z-index: 5;
}
.searchinputstyle {
  background: #fff;
  padding: 16px;
  min-height: 40px;
  border-radius: 8px;
}
.inputBgColor {
  border-radius: 16px;
  background: var(--bg-colour-box-card, #171f26);
}

.custom-select {
  min-height: 56px;
  background-color: #fff;
  border: none;
  color: #000;
  padding: 18px 22px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("../assets/rtmklik/svg/chevron-down.svg");
  background-repeat: no-repeat;
  background-size: 36px;
  border-radius: 8px;
  margin-right: 2rem;
  padding: 1rem;
  padding-right: 2rem;
}
.custom-select:focus {
  color: #000;
  border: none;
  outline: 0;
  box-shadow: 0 0 0 0.1rem #313131;
}
.tagWrapper {
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid #171f26;
  cursor: pointer;
}
.selectedCategory {
  background: #d9e021 !important;
}
.selectedCategory p {
  color: #000 !important;
}
.tagTitle {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.headerTitle {
  color: #fff;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.searchResultHeader {
  color: #d9e021;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.searchInputText {
  color: #fff;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.popularText {
  color: #fff;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.searchicon {
  width: auto;
  padding: 0 10px;
}

.inputbox {
  width: 80%;
}
.closebutton {
  width: 10%;
  cursor: pointer;
}
.closeicon {
  font-size: 16px;
  color: #000;
}
.close_text {
  font-size: 16px;
  color: #cccccc;
  margin-left: 10px;
  font-family: "HelveticaNeue-Bold";
}
input {
  border: none;
  height: 100%;
  color: #667085;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.type-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.19;
  text-align: left;
  color: #dae12f;
  font-family: "HelveticaNeue-Bold";
}
.text-yellow {
  color: #facb43;
}
h1 {
  font-family: "HelveticaNeue-Bold";
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
.svg-size {
  width: 30px;
  height: 30px;
}
@media only screen and (max-width: 768px) {
  input {
    font-size: 14px;
  }
  .searchinputstyle {
    padding: 12px 10px;
  }
  .inputbox {
    font-size: 18px;
  }
  .custom-select {
    min-height: 48px;
    font-size: 18px;
    padding: 8px 22px;
  }

  .max-container-width {
    padding: 0 8px;
  }
}
@media only screen and (max-width: 490px) {
  .inputbox {
    width: 72%;
    font-size: 14px;
  }
  .custom-select {
    font-size: 14px;
  }
  .close_text {
    font-size: 13px;
  }
  .svg-size {
    width: 20px;
    height: 20px;
  }
}
</style>
